let sdkPromise: Promise<void> | null = null;

export const loadFacebookSdk = (locale = 'pl_PL', version = 'v18.0') => {
  if (window.FB) {
    return Promise.resolve();
  }

  if (sdkPromise) {
    return sdkPromise;
  }

  sdkPromise = new Promise<void>((resolve) => {
    window.fbAsyncInit = function() {
      window.FB.init({
        xfbml: true,
        version
      });
      resolve();
    };

    if (!document.getElementById('facebook-jssdk')) {
      const js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = `https://connect.facebook.net/${locale}/sdk.js#xfbml=1&version=${version}`;
      document.head.appendChild(js);
    }
  });

  return sdkPromise;
};
